import PropTypes from "prop-types";
import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import styled from "@emotion/styled";
import { colors } from "../../../theme/colors";
import React from "react";

const Dialog = styled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    overflowY: "unset",
    boxShadow: "1px 0 0 0 #e3e3e3",
  },
  [theme.breakpoints.down("md")]: {
    "& .MuiPaper-root": {
      margin: 0,
      padding: 0,
      overflowY: "unset",
      boxShadow: "1px 0 0 0 #e3e3e3",
    },
    "& .MuiDialogTitle-root": {
      padding: "16px 24px",
    },
    "& .MuiDialogContent-root ": {
      padding: "16px 24px",
    },
  },
}));

const style = {
  closeIconButtonDesktop: {
    background: colors.text.secondaryPink,
    color: colors.common.white,
    position: "absolute",
    padding: 0,
    height: "48px",
    width: "48px",
    top: "-16px",
    right: "-16px",
    borderRadius: "100px 73px 81px 100px",
    "&:hover": {
      background: colors.error.main,
    },
  },
  closeIconButtonMobile: {
    top: "0px",
    right: "0px",
  },
};

export default function AlertDialogPopUp({
  actionPanel,
  body,
  title,

  dialogContentProps,
  dialogProps,
  dialogTitleProps,
  paperProps,
  dialogActionsProps,

  onClose,
  showClose,
  isBodyContentText,
  open,
  maxWidth,
  showCloseButtonOnFullScreen,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    open && (
      <Dialog
        fullScreen={fullScreen}
        maxWidth={maxWidth}
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            ...paperProps,
          },
        }}
        {...dialogProps}
      >
        {showClose && (
          <DialogActions
            sx={{
              padding: 0,
              zIndex: 100,
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                ...style.closeIconButtonDesktop,
                ...(fullScreen && style.closeIconButtonMobile),
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        )}

        {title && <DialogTitle {...dialogTitleProps}>{title}</DialogTitle>}

        {body && (
          <DialogContent
            {...dialogContentProps}
            dividers={fullScreen && showCloseButtonOnFullScreen}
          >
            {isBodyContentText ? (
              <DialogContentText>{body}</DialogContentText>
            ) : (
              body
            )}
          </DialogContent>
        )}
        {actionPanel && (
          <DialogActions {...dialogActionsProps}>{actionPanel}</DialogActions>
        )}
      </Dialog>
    )
  );
}

AlertDialogPopUp.defaultProps = {
  actionPanel: null,
  showClose: true,
  body: null,
  title: null,

  dialogActionsProps: {},
  dialogContentProps: {},
  dialogProps: {},
  dialogTitleProps: {},
  paperProps: {},

  onClose: () => {},

  isBodyContentText: false,
  open: false,
  maxWidth: "sm",
  showCloseButtonOnFullScreen: true,
};

AlertDialogPopUp.propTypes = {
  actionPanel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]),
  body: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]),

  dialogActionsProps: PropTypes.any,
  dialogContentProps: PropTypes.any,
  dialogProps: PropTypes.any,
  dialogTitleProps: PropTypes.any,
  paperProps: PropTypes.any,

  onClose: PropTypes.func,
  showClose: PropTypes.bool,

  isBodyContentText: PropTypes.bool,
  open: PropTypes.bool,
  showCloseButtonOnFullScreen: PropTypes.bool,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
};
